import React from "react";

import {
  Box,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useTheme } from "@mui/material/styles";

import { HelpText } from "@/components/atoms";


interface GeoModeProps {
  readOnly?: boolean;
}

export const GeoMode: React.FC<GeoModeProps> = ({ readOnly }) => {

  const theme = useTheme();

  return (
    <>
      <Grid size={12}>
        <HelpText
          text="Select File"
          helpText="Select the file you wish to upload, making sure that it adheres to the specific upload format"
          variant="body1"
        />
      </Grid>
      {!readOnly && (
        <Grid size={12}>
          <Stack spacing={1} sx={{ mb: 2 }}>
            <Typography>
              Upload a CSV file containing a postcode or sector column. Your file
              can also (optionally) include a segment column.
            </Typography>
            <Typography gutterBottom>
              An example file format is as follows
            </Typography>
            <Box sx={{ pt: 2 }}>
              <TableContainer component={Paper} sx={{ width: 240 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{}}>
                      <TableCell
                        sx={{
                          fontFamily: "cera-pro-bold",
                          borderBottomColor: theme.palette.divider,
                        }}
                      >
                        Postcode
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: "cera-pro-bold",
                          borderBottomColor: theme.palette.divider,
                        }}
                      >
                        Segment
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ borderBottomColor: theme.palette.divider }}>
                        ABC 123
                      </TableCell>
                      <TableCell sx={{ borderBottomColor: theme.palette.divider }}>
                        Segment 1
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>ABC 456</TableCell>
                      <TableCell>Segment 2</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Stack>
        </Grid>
      )}
    </>
  );
};

export default GeoMode;
